"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PLAY_TYPE_VALUES = void 0;
var PLAY_TYPE_VALUES;
(function (PLAY_TYPE_VALUES) {
    PLAY_TYPE_VALUES[PLAY_TYPE_VALUES["IN_FRAME"] = 1] = "IN_FRAME";
    PLAY_TYPE_VALUES[PLAY_TYPE_VALUES["EXPANDED_VIEW"] = 2] = "EXPANDED_VIEW";
})(PLAY_TYPE_VALUES = exports.PLAY_TYPE_VALUES || (exports.PLAY_TYPE_VALUES = {}));
//# sourceMappingURL=compact-play-type.js.map